import React from 'react'
import cn from 'classnames'
import useStore from 'state/knovStore'
import useWalletDetails from 'api/useWalletDetails'
import useBsvDisplay from 'components/shared/useBsvDisplay'
import SatsIcon from 'components/shared/SatsIcon'
import { format, SATOSHIS } from 'lib/bsv-util'
import styles from './wallet-balance-amount.module.scss'

// The viewer's wallet balance in their chosen unit: USD, sats under 1 BSV, or
// BSV above it. Shared by the top-right badge and the Wallet menu item.
export default function WalletBalanceAmount({ className = undefined } = {}) {
    const currentUserBsvWalletType = useStore(state => state.currentUserBsvWalletType)
    const { data: walletDetailsData } = useWalletDetails(currentUserBsvWalletType)
    const { useUsd, formatSatsAmount } = useBsvDisplay()
    const hasBalanceLoaded = walletDetailsData?.balanceLoaded === true
    const balance = hasBalanceLoaded ? walletDetailsData?.balance || 0 : 0
    const showAsUsd = hasBalanceLoaded && useUsd
    const showAsSats = hasBalanceLoaded && !showAsUsd && balance < SATOSHIS

    const formattedBalance = !hasBalanceLoaded
        ? '...'
        : showAsUsd
        ? formatSatsAmount(balance, { includeUnit: false, compactSats: false })
        : showAsSats
        ? format(balance)
        : (balance / SATOSHIS).toFixed(4).replace(/\.?0+$/, '')

    return (
        <span
            className={cn(
                styles.amount,
                showAsUsd ? styles.usd : showAsSats ? styles.sats : styles.btc,
                className,
            )}
            data-testid="wallet-balance-amount"
        >
            {showAsSats ? (
                <SatsIcon showBars={true} contextStyles={styles.satsIcon} />
            ) : showAsUsd ? null : (
                <i className="fa fa-btc" />
            )}
            <span>{formattedBalance}</span>
        </span>
    )
}
